import { gql } from '@apollo/client'

export const GET_ALL_ROUTES = gql`
  query GetAllRoutes(
    $limit: Int
    $offset: Int
    $searchQuery: String
    $filters: filtersRoutes
  ) {
    getAllRoutes(
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
      filters: $filters
    ) {
      count
      rows {
        id
        provider_id
        scheduled_date
        truck_id
        user_id
        frequency_spanish
        invoice
        volume
        frequency
        status_id
        RouteToUser {
          first_name
          last_name
          name
        }
        RouteToTrucks {
          id
          plate_number
        }
        RoutesToStatus {
          id
          name
          progress
          color
        }
        RouteToRoutePoints {
          id
          loaded_at
          loaded_volume
          route_id
          water_station_id
          water_truck_request_id
          delivered_at
          RoutePointsToWaterStation {
            id
            address
            name
          }
          RoutePointsToWaterTruckRequest {
            id
            status_id
            folio
            priority
            volume
            StatusOfWaterTruckRequest {
              name
              id
            }
            AddressOfWaterTruckRequest {
              id
              address_full
            }
          }
        }
        RouteToProvider {
          id
          card_name
          rfc
        }
      }
    }
  }
`

export const GET_ROUTE_BY_ID = gql`
  query GetRouteById($getRouteByIdId: Int!) {
    getRouteById(id: $getRouteByIdId) {
      id
      user_id
      truck_id
      provider_id
      invoice
      volume
      scheduled_date
      frequency
      frequency_spanish
      RouteToUser {
        id
        name
        first_name
        last_name
      }
      RouteToTrucks {
        id
        plate_number
      }
      RouteToProvider {
        id
        card_name
        rfc
      }
      RouteToRoutePoints {
        water_station_id
        route_id
        id
        water_truck_request_id
      }
    }
  }
`

export const GET_FREQUENCIES_ROUTES_OPTIONS = gql`
  query GetFrequencyRoutes {
    getFrequencyRoutes {
      value
      label
    }
  }
`

export const CREATE_ROUTE_BY_TRUCK = gql`
  mutation CreateRoute($route: RouteInput) {
    createRoute(route: $route)
  }
`

export const UPDATE_ROUTE_BY_TRUCK = gql`
  mutation UpdateRoute($updateRouteId: Int!, $route: RouteUpdateInput) {
    updateRoute(id: $updateRouteId, route: $route)
  }
`
export const DELETE_ROUTE_BY_TRUCK = gql`
  mutation DeleteRoute($deleteRouteId: Int!) {
    deleteRoute(id: $deleteRouteId)
  }
`
export const CHANGE_STATUS_TO_ROUTE = gql`
  mutation ChangeStatusToRoute(
    $changeStatusToRouteId: Int!
    $statusId: Int!
    $reason: String
  ) {
    changeStatusToRoute(
      id: $changeStatusToRouteId
      statusId: $statusId
      reason: $reason
    )
  }
`

export const COMPLETE_ROUTE_BY_ROUTE_ID = gql`
  mutation CompleteRoute($completeRouteId: Int!) {
    completeRoute(id: $completeRouteId)
  }
`
